module.exports = __webpack_public_path__ + "static/media/digital-id-resize.2c009258.svg";